/** Returns `one` when count is 1, otherwise `other`. */
export function pluralize(count: number, one: string, other: string): string {
  return Math.abs(count) === 1 ? one : other;
}
